import { createFileRoute } from '@tanstack/react-router';
import { GoogleCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/google/callback')({
  component: GoogleCallbackPage,
});
